import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import App from "./App";
import "@zkresistor/client/assets.css";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TonConnectUIProvider
      manifestUrl={`${window.location.origin}/tonconnect-manifest.json`}
      analytics={{ mode: "off" }}
    >
      <App />
    </TonConnectUIProvider>
  </StrictMode>,
);
